import React from "react";
import { Link } from 'react-router-dom';

import moment from "moment"
import { db } from "firebase/fbConfig.js"
import Button from "components/CustomButtons/Button.jsx";

export const formatTrips = (snapshot, test = false) => {
    return snapshot.docs.map(doc => {

        const commaFy = (dollarValue) => dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const numberfyString = (string) => string.replace(/[$,]+/g, "")
        const dateFormat = (fsDate) => fsDate ? moment(fsDate.toDate()).format('YYYY-MM-DD hh:MM') : 'N/A'

        const docData = {
            ...doc.data(),
            id: doc.id
        }

        let revenue = 0;
        let expenses = parseFloat(docData.tripRate ? numberfyString(docData.tripRate.toString()) : '0');

        for (let i = 0; i < docData.orders.length; i++) {
            revenue += parseFloat(numberfyString(docData.orders[i].totalRevenue.toString()));
        }

        const cmTotal = (revenue - expenses).toFixed(2);
        const cmPercent = revenue > 0 ? `${((cmTotal / revenue) * 100).toFixed(2).toString()} %` : 'N/A';
        revenue = revenue.toFixed(2);
        expenses = expenses.toFixed(2);

        return {
            ...docData,
            view: (
                <Link to={`/trips/${doc.id}`}>
                    <Button
                        color='primary'
                        fullWidth
                    >
                        VIEW
                    </Button>
                </Link>
            ),
            status: docData.status.toString() ? docData.status.toString() : 'N/A',
            pickUpBy: (
                <p>{dateFormat(docData.pickUpBy)}</p>
            ),
            dropOffBy: (
                <p>{dateFormat(docData.dropOffBy)}</p>
            ),
            totalRevenue: commaFy(revenue),
            totalExpenses: commaFy(expenses),
            cmTotal: commaFy(cmTotal),
            cmPercent
        }
    });
}

export const getTrips = (type = undefined, limited = true) => new Promise((resolve, reject) => {
    let ref = db.collection('haneyTrips');

    console.log(type)

    const tripTypes = [
        '', 
        'Owned Asset Outbound',
        'Owned Asset Inbound',
        'Owned Asset Relay',
        'Owned Asset Skip',
        'Brokered Outbound',
        'Brokered Inbound',
        'Brokered Relay',
        'Brokered Skip',
        'In-Town Pickup',
        'In-Town Delivery',
        'In-Town Trailer Drop',
        'In-Town Trailer Recovery',
        'Storage Trailer',
        'Dead Head'];

        switch (type) {
            case 'OTR':
      
                ref = ref.where('tripType', 'in', ['OTR', 'Owned Asset Outbound', 'Owned Asset Inbound', 'Owned Asset Relay', 'Owned Asset Skip']);

                ref = ref.orderBy('tripNumber', 'desc')
            
                if (limited) ref = ref.limit(1000);
            
                ref.get()
                    .then(resolve)
                    .catch(reject);
      
              break;
      
            case 'Broker':
      
                ref = ref.where('tripType', 'in', ['Broker', 'Brokered Outbound', 'Brokered Inbound', 'Brokered Relay', 'Brokered Skip']);

                ref = ref.orderBy('tripNumber', 'desc')
            
                if (limited) ref = ref.limit(1000);
            
                ref.get()
                    .then(resolve)
                    .catch(reject);
      
              break;

              case 'Local':
      
                ref = ref.where('tripType', 'in', ['Local', 'In-Town Pickup', 'In-Town Delivery', 'In-Town Trailer Drop', 'In-Town Trailer Recovery']);

                ref = ref.orderBy('tripNumber', 'desc')
            
                if (limited) ref = ref.limit(1000);
            
                ref.get()
                    .then(resolve)
                    .catch(reject);
      
              break;

              default:

                ref = ref.orderBy('tripNumber', 'desc')
            
                if (limited) ref = ref.limit(1000);
            
                ref.get()
                    .then(resolve)
                    .catch(reject);
          }


    
})


// WEBPACK FOOTER //
// ./src/tables/rows/trips.js